<template>
  <div>
    <div v-if="loading" class="d-flex justify-center align-center">
      <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
    </div>

    <v-tabs
      v-else
      background-color="primary"
      dark
      slider-color="yellow"
      :value="activeTab"
      @change="updateTab"
    >
      <v-tab v-for="(item, index) in items" :key="index">{{ item.name }}</v-tab>
      <v-tabs-items v-model="activeTab" style="height:100%" touchless>
        <v-tab-item
          v-for="(item, index) in items"
          :key="index"
        >
          <component
            style="height:100%"
            :loading="loading"
            v-bind:is="item.component"
            v-bind="item.properties"
            :location="location"
          ></component>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
  // Components
  import LocationTransaction from '@/components/Common/Rental/Locations/Transaction'
  import LocationStock from '@/components/Common/Rental/Locations/Stock'
  import LocationInformation from '@/components/Common/Rental/Locations/Information'
  import ProductSales from '@/components/Common/Rental/Locations/ProductSales'
  import ProductList from '@/components/Common/Rental/Locations/ProductList'

  // Services
  import {mapGetters, mapMutations} from 'vuex'

  export default {
    props: {
      locationService: Object,
      transactionService: Object,
      productService: Object,
    },

    components: {
      LocationTransaction,
      LocationStock,
      LocationInformation,
      ProductSales,
      ProductList
    },

    computed: {
      ...mapGetters('acl', [
        'matchRoles'
      ]),

      items () {
        let items = []

        items.push({
          name: 'Stocks',
          component: 'LocationStock'
        })

        if (this.matchRoles('machine_operation')) {
          items.push({
            name: 'Products',
            component: 'ProductList'
          })
        }

        items.push({
          name: 'Transactions',
          component: 'LocationTransaction',
          properties: {
            locationService: this.locationService,
            transactionService: this.transactionService,
            productService: this.productService,
          },
        })
        items.push({
          name: 'Information',
          component: 'LocationInformation'
        })
        items.push({
          name: 'Sales By Product',
          component: 'ProductSales'
        })
        return items
      }
    },

    mixins: [
    ],

    data () {
      return {
        loading: false,

        activeTab: null,

        location: null
      }
    },

    created () {
      this.loading = true

      this.locationService
        .get(this.$route.params.id)
        .then(({ data }) => {
          this.location = data.data

          if (this.location.name && this.$route.name === 'RentalLocation') {
            this.$store.commit('UPDATE_TITLE', `Location - ${this.location.name}`)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    methods: {
      ...mapMutations('tabs', ['SET_ITEMS']),

      updateTab (value) {
        this.activeTab = value
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/Rental/Locations/Location.vue